import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { Box } from '@mui/material';
import { useTheme } from '../themeContext';

// -- Components 

import Notification from '../components/general/notification/Notification';

// Utils 

import LockScreenContent from '../components/lockScreen/LockScreenContent'; // Renamed import

const LockScreen: React.FC = () => {

  const colors = useAppSelector(state => state.theme.colors);

  // -- 

  return (
    <Box
      component="main"
      maxWidth="xs"
      sx={{
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'space-evenly', 
        height: '100vh', 
        width: '100vw',
        left: 0, 
        overflowX: 'hidden',
        position: 'absolute',
        color: colors?.highlightedText
      }}
    >
    
      <LockScreenContent /> {/* Render the renamed component */}

      <Notification />

    </Box>
  );
};

export default LockScreen;